import { render } from "./TiktokFormInput.vue?vue&type=template&id=9c815408&scoped=true&ts=true"
import script from "./TiktokFormInput.vue?vue&type=script&lang=ts"
export * from "./TiktokFormInput.vue?vue&type=script&lang=ts"

import "./TiktokFormInput.vue?vue&type=style&index=0&id=9c815408&scoped=true&lang=css"

import exportComponent from "/home/kuradmin/dev-frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c815408"]])

export default __exports__